/**
 * The statement the Query Editor's "Query a table" seed writes into the
 * buffer: `SELECT <first N rows> * FROM <schema>.<table>;` in the engine's
 * own limit dialect. Reuses the data-profile quoting/limit helpers and the
 * shared `SELECT_TOP_ROW_LIMIT` so this stays byte-compatible with what the
 * Object Explorer's "Select top N rows" action emits, minus the line breaks
 * (the seed is shown as a one-line preview in the picker footer).
 *
 * Returns `null` for engines the Visual Query Editor cannot edit (Kusto has
 * no SQL SELECT shape to seed) — the affordance hides itself in that case.
 */
import type { DatabaseEngineId } from '../../../../core/engines';
import { SELECT_TOP_ROW_LIMIT } from '../../../scripting/selectTopRowLimit';
import { qualifyTable, rowLimitClauses } from '../../data-profile/utils/sqlIdentifierQuoting';

export function buildTableSeedSql(
  engine: DatabaseEngineId,
  schema: string,
  table: string,
): string | null {
  if (engine === 'kusto') return null;
  const { prefix, suffix } = rowLimitClauses(engine, SELECT_TOP_ROW_LIMIT);
  return `SELECT ${prefix}* FROM ${qualifyTable(engine, schema, table)}${suffix};`;
}
